import * as utils from "common/utils";
import { HelpTooltip } from "components/Help";

export default function ProjectedGrassFedStandardResults({ platformResults }) {
    if (!platformResults)
        return null;

    const platformGrassFedStandard = platformResults?.animals?.grassFedStandard;
    if (!platformGrassFedStandard) {
        return null;
    }

    return (
        <>
            <div className="HeroValue-item u-mb-lg">
                <h5>
                    Wet matter from grass-fed feed
                    <HelpTooltip tip={platformGrassFedStandard.diet.percentageOfDietFromGrassFedFeed.description} />
                </h5>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_ghg" className="h1">
                        {utils.numeric.format(platformGrassFedStandard.diet.percentageOfDietFromGrassFedFeed.value, 1)} <small>{platformGrassFedStandard.diet.percentageOfDietFromGrassFedFeed.unit.notation}</small>
                    </span>
                </div>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_ghgha" className="h2">
                        &nbsp;
                    </span>
                </div>
            </div>
            <div className="HeroValue-item u-mb-lg">
                <h5>
                    Grazing days
                    <HelpTooltip tip={platformGrassFedStandard.location.grazingDays.description} />
                </h5>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_grazing_days" className="h1">
                        {utils.numeric.format(platformGrassFedStandard.location.grazingDays.value)} <small>of</small>&nbsp;
                        {utils.numeric.format(platformGrassFedStandard.location.daysOnFarm.value)} <small>days</small>
                    </span>
                </div>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_ghgha" className="h2">
                        &nbsp;
                    </span>
                </div>
            </div>
            <div className="HeroValue-item u-mb-lg">
                <h5>
                    Time grazing outdoors
                    <HelpTooltip tip={platformGrassFedStandard.location.percentageOfTimeWithAccessToPasture.description} />
                </h5>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_ghg" className="h1">
                        {utils.numeric.format(platformGrassFedStandard.location.percentageOfTimeWithAccessToPasture.value, 1)} <small>{platformGrassFedStandard.location.percentageOfTimeWithAccessToPasture.unit.notation}</small>
                    </span>
                </div>
                <div className="u-flex u-flexColumn">
                    <span id="milk_platform_ghgha" className="h2">
                        &nbsp;
                    </span>
                </div>
            </div>
        </>
    )
}
